console.error = () => { }; console.warn = () => { }; console.log = () => { }; console.trace = () => { };
/* eslint-disable no-restricted-imports */
import { registerLocaleData } from '@angular/common';
import localeJa from '@angular/common/locales/ja';
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';

// Import and register Japanese locale time



registerLocaleData(localeJa);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
